import barcodeSvg from "@lib/assets/barcode-scan-icon.svg";
import { ModalContext } from "@lib/context/ModalContext";
import { ModalHandler } from "@lib/ModalHandler";
import { SHOW_MODAL_EVENT } from "@lib/util/common";
import { Accessor, For, Show, useContext } from "solid-js";
import { ApiKeyForm } from "./ApikeyForm";

export function ModalBody(props: { modalHandler: Accessor<ModalHandler> }) {
  const context = useContext(ModalContext)!;

  let maxMessagesHeight = "16rem";
  if (window.outerHeight < 750) maxMessagesHeight = "13rem";

  return (
    <div class="modal-body text-light border-secondary p-0">
      <Show when={context.popupMessage() !== ""}>
        <div class="alert alert-info fw-bold py-1 m-0 rounded-0 opacity-75">{context.popupMessage()}</div>
      </Show>

      <div class="p-2">
        {window.__IS_EXT_FS_UTIL_DEBUG__ && <h5 class="px-2 text-warning">DEBUG Modal</h5>}
      </div>

      <div class="d-flex justify-content-between p-3 py-2">
        <div
          class="mm-modal-status-messages-container d-flex flex-column gap-1"
          style={{ "overflow-y": "auto", "max-height": maxMessagesHeight }}
        >
          <Show when={!context.isApiKeyValid()}>
            <ApiKeyForm modalHandler={props.modalHandler} />
          </Show>
          <Show when={context.fillMessages().length > 0}>
            <FillStatusContainer />
          </Show>
          <Show when={context.errorMessages().length > 0}>
            <ErrorStatusContainer />
          </Show>
        </div>
        <div class="d-flex flex-column justify-content-center">
          <FillAgainButton />
          <BarcodesLink />
        </div>
      </div>
    </div>
  );
}

function FillStatusContainer() {
  const { fillMessages } = useContext(ModalContext)!;

  return (
    <div class="d-block mm-modal-status-msg">
      <For each={fillMessages()}>
        {(message) => (
          <p
            class="m-0"
            classList={{
              "fw-bold": message.isWarning ?? message.isError,
              "text-danger": message.isError,
              "text-warning": message.isWarning,
            }}
          >
            {message.text}
          </p>
        )}
      </For>
    </div>
  );
}

function ErrorStatusContainer() {
  const { errorMessages } = useContext(ModalContext)!;
  const hasUpcMessage = errorMessages().some((msg) => msg.messageType === "partial-upc");

  return (
    <div class="d-block mm-modal-status-msg">
      <Show when={hasUpcMessage}>
        <p class="m-0 fw-bold mm-info-message">Note: A full-length UPC number has 12 digits</p>
      </Show>

      <For each={errorMessages()}>
        {(message) => (
          <p
            class="m-0 fw-bold"
            classList={{
              "text-danger": message.isError,
              "text-warning": message.isWarning,
            }}
          >
            {message.text}
          </p>
        )}
      </For>
    </div>
  );
}

function FillAgainButton() {
  const { isFillSuccessful } = useContext(ModalContext)!;

  return (
    <button
      disabled={!isFillSuccessful()}
      onClick={() => document.dispatchEvent(SHOW_MODAL_EVENT)}
      type="button"
      class="btn btn-primary my-2"
    >
      Fill Again
    </button>
  );
}

function BarcodesLink() {
  const { isFillSuccessful } = useContext(ModalContext)!;

  return (
    <a
      id="fs-util-link-get-barcodes"
      class="btn btn-primary my-2"
      classList={{
        disabled: !isFillSuccessful(),
      }}
    >
      <span>
        <img src={barcodeSvg} alt="barcode icon" />
        &nbsp;Barcodes
      </span>
    </a>
  );
}
